var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"450px"},attrs:{"id":"resourcemap"}})
}
var staticRenderFns = []

export { render, staticRenderFns }